import React, { useState, useCallback, useEffect, forwardRef } from 'react';
import AspectRatio from '@mui/joy/AspectRatio';
import Typography from '@mui/joy/Typography';
import Box from '@mui/joy/Box';
import Sheet from '@mui/joy/Sheet';
import Stack from '@mui/joy/Stack';
import { styled } from '@mui/joy/styles';
import Grid from '@mui/joy/Grid';


/////////////////// Modal
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';


////////////// Menu DropDown
import IconButton from '@mui/joy/IconButton';
import Menu from '@mui/joy/Menu';
import MenuItem from '@mui/joy/MenuItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListDivider from '@mui/joy/ListDivider';
import MoreVert from '@mui/icons-material/MoreVert';
import Edit from '@mui/icons-material/Edit';
import DeleteForever from '@mui/icons-material/DeleteForever';
import MenuButton from '@mui/joy/MenuButton';
import Dropdown from '@mui/joy/Dropdown';

import PanerAdImage from '../../assets/panerAd.png';

///////////////////// Modal
import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import SvgIcon from '@mui/joy/SvgIcon';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


import HideIcon from '../../assets/icons/hideIcon.svg'
import TrashIcon from '../../assets/icons/trashIcon.svg'
import AddBoxIcon from '@mui/icons-material/AddBox';
import ImagePlaceholder from '../../assets/imagePlaceholder.png';
import EditIcon from '../../assets/icons/edit.svg'


//////////////////////// API
import { createAd, getAds, changeStatusAd, deleteAd, updateAd } from '../../Api/common';

// const schema = yup.object({
//     image: yup.mixed().required("يرجى رفع صورة للاعلان"),
// })




const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

export default function PanerAdPage(props) {
    const { listAdsTwo, getAllAdsSectionTwo } = props;

    const [listAllAds, setListAllAds] = useState([]);
    const [open, setOpen] = useState(false);
    const [urlImage, setUrlImage] = useState(ImagePlaceholder)
    const [imageDataTwo, setImageDataTwo] = useState(null)


    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const [roleId, setRoleId] = useState([])
    const [adminType, setAdminType] = useState(null)
    const [adId, setAdId] = useState(null)
    const [actionSubmit, setActionSubmit] = useState(null)


    const schema = yup.object({
        image: actionSubmit != 'edit' ? yup.mixed().required("يرجى رفع صورة للاعلان") : null,
        // link: yup.string().required("يرجى ادخال الرابط"),
    })


    const form = useForm({
        defaultValues: {
            link: '',
            image: null,
            type: '2'
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };


    const openModalPopUp = () => {
        setActionSubmit(null)
        setOpen(true)
        setValue('link', null)
        setValue('image', null)
        setUrlImage(ImagePlaceholder)
    };

    const getAllAds = useCallback(async () => {
        const res = await getAds('2');
        if (res) {
            setListAllAds(res)
        }
    }, []);


    const sendImageAd = async (data) => {
        setLoading(true)

        if (actionSubmit == 'edit') {
            if (data.image) {
                data.image = data.image[0]
            }
            try {
                const res = await updateAd(adId, data)
                if (res) {
                    setLoading(false)
                    setOpen(false)
                    getAllAds()
                    setOpenAlert(true)
                    setMessageAlert('تم تعديل الاعلان بنجاح')
                    setValue('image', null)
                    setValue('link', '')
                    setImageDataTwo(null)
                    setActionSubmit(null)
                    setUrlImage(ImagePlaceholder)
                }

            } catch (error) {
                if (error.response) {
                    setLoading(false)
                    setOpen(false)
                    setOpenAlertError(true)
                    setMessageAlertError(error.response.data.message)
                }
            }
        } else {

            try {
                if (data.image) {
                    data.image = data.image[0]
                }
                const res = await createAd(data)
                if (res) {
                    setLoading(false)
                    setOpen(false)
                    getAllAds()
                    setOpenAlert(true)
                    setMessageAlert('تم اضافة الاعلان بنجاح')
                    setValue('image', null)
                    setValue('link', '')
                    setImageDataTwo(null)
                    setUrlImage(ImagePlaceholder)
                }

            } catch (error) {
                if (error.response) {
                    setLoading(false)
                    setOpen(false)
                    setOpenAlertError(true)
                    setMessageAlertError(error.response.data.message)
                }
            }
        }


        // if (data.image) {
        //     data.image = data.image[0]
        // }

        // try {
        //     const res = await createAd(data)
        //     if (res) {
        //         setLoading(false)
        //         setOpen(false)
        //         getAllAds()
        //         setOpenAlert(true)
        //         setMessageAlert('تم اضافة الاعلان بنجاح')
        //         setValue('image', null)
        //         setValue('link', '')
        //         setImageDataTwo(null)
        //         setUrlImage(ImagePlaceholder)
        //     }

        // } catch (error) {
        //     if (error.response) {
        //         setLoading(false)
        //         setOpen(false)
        //         setOpenAlertError(true)
        //         setMessageAlertError(error.response.data.message)
        //     }
        // }

    };

    const imgAd = (event) => {
        let image = event.target;
        if (image.files && image.files[0]) {
            setImageDataTwo(image.files[0]);
            console.log(imageDataTwo)
            var reader = new FileReader();
            reader.onload = (e) => {
                setUrlImage(e.target.result);
            }
            reader.readAsDataURL(image.files[0]);
        }
    };

    const changeStatus = async (id, typeAction) => {
        if (typeAction == 0) {
            const res = await changeStatusAd(id, 0)
            if (res) {
                setOpenAlert(true)
                setMessageAlert('تم تغير حالة الاعلان واخفائه بنجاح')
                getAllAds()
            }
        } else {
            const res = await changeStatusAd(id, 1)
            if (res) {
                setOpenAlert(true)
                setMessageAlert('تم تغير حالة الاعلان واظهاره بنجاح')
                getAllAds()
            }
        }
    }

    const removeAd = async (id) => {
        const res = await deleteAd(id)
        if (res) {
            setOpenAlert(true)
            setMessageAlert('تم حذف الاعلان بنجاح')
            getAllAds()
        }
    };

    const editAd = async (id) => {
        let adDetails = listAllAds.filter((ad) => ad.id == id);
        if (adDetails) {
            setAdId(id)
            setActionSubmit('edit')
            setOpen(true)
            // setValue('image', adDetails.image)
            setUrlImage(adDetails[0].image)
            setValue('link', adDetails[0].link)
        }
    }



    useEffect(() => {
        getAllAds();
    }, [getAllAds])



    const getRoleAamin = useCallback(async () => {
        let role = await JSON.parse(localStorage.getItem("adminRoleSoomha"));
        let typeAdmin = await JSON.parse(localStorage.getItem("typeAdminSoomha"));
        let roles = role.map((roleIds) => {
            return roleIds.role_id
        })
        let numberArray = roles.map(Number);
        setRoleId(numberArray)
        setAdminType(typeAdmin)
    }, [])


    useEffect(() => {
        getRoleAamin()
    }, [getRoleAamin])


    return (
        <>

            {/* Section Modal */}
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={open}
                onClose={() => setOpen(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        maxWidth: 500,
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                    }}
                >
                    <ModalClose variant="plain" sx={{ m: 1 }} />
                    <form onSubmit={handleSubmit(sendImageAd)}>
                        <FormControl sx={{ direction: 'rtl', marginBottom: '20px', marginTop: '40px' }}>
                            <FormLabel>الرابط</FormLabel>
                            <Input
                                sx={{
                                    height: '60px',
                                    borderRadius: '30px'
                                }}
                                autoFocus
                                placeholder='ادخل الرابط هنا.....'
                                {...register('link')}
                            />
                            {/* {errors.link &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.link?.message}</Typography>
                            } */}
                        </FormControl>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                            <img src={urlImage} className='viewImageAd' alt='image ad' />
                            {errors.image &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                    sx={{ textAlign: 'center' }}
                                >{errors.image?.message}</Typography>
                            }
                            <Typography level="h4" sx={{textAlign:'center', margin:'20px 0'}}>يجب رفع صورة بمقاس 1400 * 270</Typography>
                            
                            <Button
                                component="label"
                                role={undefined}
                                tabIndex={-1}
                                variant="outlined"
                                color="neutral"
                                sx={{ marginTop: '20px', width: '200px', margin: '20px auto' }}
                                startDecorator={
                                    <SvgIcon>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                                            />
                                        </svg>
                                    </SvgIcon>
                                }
                            >
                                رفع صورة اعلان
                                <VisuallyHiddenInput type="file" {...register('image')} onChange={(e) => imgAd(e)} />
                            </Button>

                            <Button sx={{ width: '250px', margin: 'auto' }} type='submit' loading={loading}>{actionSubmit == 'edit' ? 'تعديل الاعلان' : 'انشاء الاعلان'}</Button>
                        </Box>
                    </form>
                </Sheet>
            </Modal>

            {/* Alert Message */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>



            <Grid sx={{ padding: '30px 0', backgroundColor: '#F7F9FB' }}>
                <Typography level="h2" fontSize="xl" sx={{ mr: 3 }}>
                    القسم الثانى
                </Typography>
            </Grid>

            {listAllAds.map((pannerItem) => {
                return (
                    <Box component="section" sx={{ position: 'relative', width: '100%', height: '250px', borderRadius: '10px', overflow: 'hidden', marginBottom: '20px' }} key={pannerItem.id}>
                        {(adminType == 0 || roleId.includes(2)) ? (
                            <Dropdown>
                                <MenuButton
                                    slots={{ root: IconButton }}
                                    slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                                    sx={{ position: 'absolute', top: '20px', left: '8px', borderRadius: '50%', backgroundColor: '#FFF', zIndex: '3' }}
    
                                >
                                    <MoreVert />
                                </MenuButton>
                                <Menu placement="bottom-end">
                                    {pannerItem.status == 1 ? (
                                        <MenuItem sx={{ color: '#434448' }} onClick={() => changeStatus(pannerItem.id, 0)}>
                                            <ListItemDecorator>
                                                <img src={HideIcon} alt='icon' />
                                            </ListItemDecorator>{' '}
                                            إخفاء الاعلان
                                        </MenuItem>
                                    ) : (
                                        <MenuItem sx={{ color: '#434448' }} onClick={() => changeStatus(pannerItem.id, 1)}>
                                            <ListItemDecorator>
                                                <img src={HideIcon} alt='icon' />
                                            </ListItemDecorator>{' '}
                                            اظهار الاعلان
                                        </MenuItem>
                                    )}
                                    {(adminType == 0 || roleId.includes(2)) ? (
                                        <MenuItem sx={{ color: '#434448' }} onClick={() => editAd(pannerItem.id)}>
                                            <ListItemDecorator sx={{ color: 'inherit' }}>
                                                <img src={EditIcon} alt='icon' />
                                            </ListItemDecorator>{' '}
                                            تعديل الاعلان
                                        </MenuItem>
                                    ) : null}
    
                                    {(adminType == 0) ? (
                                        <MenuItem sx={{ color: '#434448' }} onClick={() => removeAd(pannerItem.id)}>
                                            <ListItemDecorator sx={{ color: 'inherit' }}>
                                                <img src={TrashIcon} alt='icon' />
                                            </ListItemDecorator>{' '}
                                            حذف الاعلان
                                        </MenuItem>
                                    ) : null}
    
                                    {/* <MenuItem sx={{ color: '#434448' }} onClick={() => removeAd(pannerItem.id)}>
                                        <ListItemDecorator sx={{ color: 'inherit' }}>
                                            <img src={TrashIcon} alt='icon' />
                                        </ListItemDecorator>{' '}
                                        حذف الاعلان
                                    </MenuItem> */}
                                </Menu>
                            </Dropdown>
                
                        ):null}
                        <img src={pannerItem.image} alt="ads" width='100%' height='100%' />
                    </Box>
                )
            })}


            {(adminType == 0 || roleId.includes(1)) ? (
                <Box
                    component="section"
                    onClick={openModalPopUp}
                    sx={{
                        width: '32%',
                        height: '150px',
                        backgroundColor: '#FFF',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'center',
                        flexDirection: 'column',
                        paddingTop: '40px',
                        boxSizing: 'border-box',
                        cursor: 'pointer'
                    }}>
                    <AddBoxIcon sx={{ color: '#3E64F4', fontSize: '30px' }} />
                    <Typography level="h4" sx={{ color: '#3E64F4' }}>أضف اعلان جديد</Typography>
                </Box>
            ) : null}
        </>
    )
}